import { v4 as uuidv4 } from 'uuid'
import { Section } from '../draggable/types'

const valuationReportStructure = [
  {
    name: 'Valuation Summary',
    chapters: [
      'Valuation Overview',
      'Property Description',
      'Qualifications'
    ]
  },
  {
    name: 'Scope of Work',
    chapters: [
      'Identification and status of the responsible valuer',
      'Professional Indemnity Insurance',
      'Limitations on Liability',
      'Statement of Independence',
      'Purpose of Valuation',
      'Property Identification',
      'Basis of Value',
      'Valuation & Investigation dates',
      "Nature and extent of the valuer's work including investigation and limitations thereon",
      'ESG Reporting requirements',
      'Nature and source(s) of information',
      'Assumptions',
      'Special Assumptions',
      'Departures',
      'Restrictions on use, distribution and publication of the report',
      'Valuation Standards',
      'RICS Monitoring',
      'Valuation approach and reasoning',
      'Liquidation value estimate',
      'VPGA 10 - Material valuation uncertainty',
      'Disclosures',
      'Market identification and input level',
      'Consistency between adopted basis of value and market value',
      'Conflict of interest'
    ]
  },
  {
    name: 'Target Property Summary',
    chapters: [
      'Location',
      'Landmarks',
      'Property Details',
      'Revenue and costs',
      'Pictures'
    ]
  },
  {
    name: 'Valuation',
    disabled: true,
    chapters: []
  },
  {
    name: 'Certifications',
    chapters: [
      'Agency',
      'Lead Valuer',
      'Supporting Member'
    ]
  },
  {
    name: 'Disclosures',
    chapters: [
      'Conflict of Interests',
      'Additional Disclosures'
    ]
  },
  {
    name: 'Additional Property Details',
    chapters: [
      'Additional Documents',
      'Condition Ratings',
      'Property observation checklist for identifying potential environmental issues',
      'Size',
      'ESG Label & Certificate'
    ]
  },
  {
    name: 'Additional Comparable Details',
    chapters: []
  },
  {
    name: 'Market Research',
    chapters: []
  },
  {
    name: 'Ancillary Information',
    chapters: []
  },
  {
    name: 'Other Documents',
    chapters: []
  },
  {
    name: 'Calculation Details',
    chapters: []
  }
]

export const defaultSections: Section[] = valuationReportStructure.map(item => {
  return {
    id: uuidv4(),
    name: item.name,
    defaultName: item.name,
    included: true,
    disabled: item.disabled ? item.disabled : false,
    chapters: item.chapters.map(name => {
      return {
        id: uuidv4(),
        name: name,
        defaultName: name,
        included: true
      }
    })
  }
})